export const eventHistoryPath = (orderId: number, eventId: number | string): string =>
  `/orders/${orderId}/events/${eventId}/history`;
